/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { AddMarks } from './marksControl/addMarks';
import { TableCompanies } from './marksControl/tableCompanies';
import { CreateReportsAllDate } from './reportsControl/createReportsAllDate';
//import { MyPortal } from './components/my-portal'

const controlPanelBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ControlPanelPage: FC = () => {
  const [myRefresh, setMyRefresh] = useState<boolean>(false);

  return (
    <div className='column g-5 g-xl-8'>

        <h3 className='card-title align-items-start flex-column mb-5'>
            <span className='card-label fw-bold fs-3 mb-1'>Portais</span>
        </h3>

        {/* <AddMarks myRefresh={myRefresh} setMyRefresh={setMyRefresh}/> */}
        {/* <TableCompanies myRefresh={myRefresh}/> */}


        <h3 className='card-title align-items-start flex-column mb-5'>
            <span className='card-label fw-bold fs-3 mb-1'>Concessionarias</span>
        </h3>

        {/* <AddMarks myRefresh={myRefresh} setMyRefresh={setMyRefresh}/> */}

        <h3 className='card-title align-items-start flex-column mb-5'>
            <span className='card-label fw-bold fs-3 mb-1'>Relatorios (DETALHADOS)</span>
        </h3>

        <CreateReportsAllDate myRefresh={myRefresh} setMyRefresh={setMyRefresh}/>

        <h3 className='card-title align-items-start flex-column mb-5'>
            <span className='card-label fw-bold fs-3 mb-1'>Faturas</span>
        </h3>

        {/* <AddMarks myRefresh={myRefresh} setMyRefresh={setMyRefresh}/> */}

    </div>
  )
}

const ControlPanelWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={controlPanelBreadcrumbs}>Painel de Controle</PageTitle>
      <ControlPanelPage />
    </>
  )
}

export {ControlPanelWrapper}


